import { FC, memo, useState } from 'react'

import { MathVaultLink } from '~/types/math-vault'

import { SubMenuItem } from './SubMenuItem'

interface SubMenuProps {
  items: MathVaultLink[]
}

const SubMenuComponent: FC<SubMenuProps> = ({ items }) => {
  const [itemSubMenu, setItemSubMenu] = useState<MathVaultLink[]>([])
  const [showSubMenu, setShowSubMenu] = useState(false)
  const [activeClass, setActiveClass] = useState({ path: '', className: '' })
  const handleOnMouseLeave = (): void => {
    setItemSubMenu([])
    setShowSubMenu(false)
    setActiveClass({ path: '', className: '' })
  }

  const handleOnMouseEnter = (item: MathVaultLink): void => {
    if (item.children) {
      setItemSubMenu(item.children)
      setShowSubMenu(true)
    }

    setActiveClass({
      path: item.path,
      className: item.activeClass.bg,
    })
  }

  return (
    <div className="flex pl-4" onMouseLeave={handleOnMouseLeave}>
      <div className="shrink flex flex-col">
        {items.map((item) => (
          <SubMenuItem
            activeClassName={activeClass.path === item.path ? activeClass.className : ''}
            item={item}
            key={item.key}
            onMouseEnter={handleOnMouseEnter}
          />
        ))}
      </div>
      {showSubMenu && <SubMenu items={itemSubMenu} />}
    </div>
  )
}
export const SubMenu = memo(SubMenuComponent)
